"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const registryCheckErrors = (0, graphql_tag_1.default)`
  query registry_problems {
    registry {
      problems {
        objectName
        type
        houses {
          address
          buildingId
          problems {
            name
            value
            type
            count
            ownedArea
            ownershipPercent
            link
          }
          settings {
            id
            maxAreaSize
            maxApartmentsAmount
            currentAreaSize
            currentUnitAmount
            areaFromOpenSource
            amountFromOpenSource
          }
          settingsVillage {
            maxBuildingsAmount
            currentBuildingsAmount
          }
        }
      }
    }
  }
`;
exports.default = registryCheckErrors;